import type { Device } from '~/types';

export const DESKTOP_MIN_WIDTH = 768;

export default function useGetDevice(): UseGetDeviceReturn {
  const { width } = useWindowSize();
  const { isMobileOrTablet } = useDevice();

  const device = computed<Device>(() => {
    if (width.value < DESKTOP_MIN_WIDTH || isMobileOrTablet) {
      return 'mobile';
    }
    return 'desktop';
  });

  const isDesktop = computed(() => {
    return device.value === 'desktop';
  });

  const isMobile = computed(() => {
    return device.value === 'mobile';
  });

  return {
    device,
    isDesktop,
    isMobile,
  };
}

interface UseGetDeviceReturn {
  device: ComputedRef<Device>;
  isDesktop: ComputedRef<boolean>;
  isMobile: ComputedRef<boolean>;
}
